import ContractsTaxiDriverDetailsResponse, {
  ContractsTaxiDriverDetailsResponseItem,
  ContractsTaxiDriverDetailsResponseItemModel,
} from "../../../../api/raily/contracts/taxi-driver/details/contracts-taxi-driver-details.response";
import BillingModel from "../../../../types/billing-model";
import DateRange from "../../../../types/date-range";
import ContractsTaxiDriverDetails from "./contracts-taxi-driver-details";

const createBillingModel = (
  responseBillingModel: ContractsTaxiDriverDetailsResponseItemModel,
): BillingModel => {
  switch (responseBillingModel) {
    case ContractsTaxiDriverDetailsResponseItemModel.AB:
      return BillingModel.AB;
    case ContractsTaxiDriverDetailsResponseItemModel.ABA:
      return BillingModel.ABA;
    case ContractsTaxiDriverDetailsResponseItemModel.SABS:
      return BillingModel.SABS;
    case ContractsTaxiDriverDetailsResponseItemModel.OTHER:
      return BillingModel.OTHER;
  }
};

const createDateRange = (
  item: ContractsTaxiDriverDetailsResponseItem,
): DateRange => {
  return {
    from: item.validSince,
    to: item.validTo,
  };
};

const create = (
  response: ContractsTaxiDriverDetailsResponse,
): ContractsTaxiDriverDetails => {
  return {
    billingModel: createBillingModel(response.data.model),
    distanceRate: response.data.distanceRate,
    freeStoppingPeriodMinutes: response.data.haltingTimeAfterMinutes,
    isActive: !response.data.disabled,
    periodOfValidity: createDateRange(response.data),
    stoppingRate: response.data.haltingTimeRate,
    notes: response.data.description,
  };
};

const contractsTaxiDriverDetailsFactory = {
  create,
};

export default contractsTaxiDriverDetailsFactory;
